/**
 * Web Style Import
 *
 */

import '../../style/themes/theme-ui/ui-theme-components.scss'
